import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Authentication guard — blocks unauthenticated users.
 *
 * - Waits for auth restoration from localStorage (survives page refresh).
 * - Redirects to /login when token is missing or expired.
 * - Preserves the attempted URL so login can redirect back (optional enhancement).
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isAuthReady, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthReady) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
